import { fetchWrapper } from "@coxauto-ui/core-http";
import { getMediaBffBaseUrl, getMediaBffHeader } from "../config";

// entityType "OE" = Operating Entity (used for Customer Inbox with coOrgId)
const ENTITY_TYPE = "OE";

export async function getMediaEntitlement(coOrgId: string): Promise<boolean> {
  const url = `${getMediaBffBaseUrl()}/api/media/entitlement/entityType/${ENTITY_TYPE}/entityId/${encodeURIComponent(
    coOrgId
  )}`;

  try {
    const header = await getMediaBffHeader(coOrgId);
    const response = await fetchWrapper.sendAsyncText({
      method: "GET",
      url,
      headers: header
    });
    if (response?.statusCode && response.statusCode >= 500) {
      // eslint-disable-next-line no-console
      console.error(
        `[getMediaEntitlement] media-bff returned ${response.statusCode} — this is a server error, not an entitlement denial. coOrgId: ${coOrgId}`
      );
    }
    return response?.statusCode === 200 && !response.hasError;
  } catch {
    return false;
  }
}
